// extracted by mini-css-extract-plugin
export default {"main":"RemoveConfirmModal_main__08wMk","body":"RemoveConfirmModal_body__3I-OA","actions":"RemoveConfirmModal_actions__+0GKg"};